import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Link } from "react-router-dom";
import debounce from "lodash.debounce";

import GenericTableComponent from "../../components/common/Table";
import { getAllTeamMembers } from "../../redux/slices/userSlice";
//import { convertToLocalCurrency } from '../../utils/currency';

const columns = [
  { id: "firstName", label: "First name" },
  { id: "lastName", label: "Last name" },
  { id: "email", label: "Email address" },
  { id: "role", label: "Role" },
  { id: "isActive", label: "Status" },
];
const TeamTab = () => {
  const dispatch = useDispatch();
  const { teamMembers, meta, loading } = useSelector((state) => state.user);
  //console.log(meta)
  
//console.log(teamMembers)
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(getAllTeamMembers({ page, rowsPerPage }));
  }, [dispatch, page, rowsPerPage]);

  const handlePageChange = (event, newPage) => {
      setPage(newPage);
    dispatch(getAllTeamMembers({ page: newPage, rowsPerPage }));
  };
  
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    dispatch(getAllTeamMembers({ page: 0, rowsPerPage: newRowsPerPage }));
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm) => {
        dispatch(getAllTeamMembers({ page: 0, rowsPerPage, name: searchTerm }));
      }, 2000),
    [dispatch, rowsPerPage]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const triggerSearch = () => {
    
    dispatch(getAllTeamMembers({ page: 0, rowsPerPage, name: search }));
  };

  return (
    <div>
      <TableWrapper>
        <div className='header'>
          <div className='texts'>
            <h5>Team members</h5>
          </div>
          <div className='link-buttons'>
            {/* <Link className='see-more' to="">Download CSV</Link> */}
            <Link className='add-campaign'to="/create-member">+ Add member</Link>
          </div>
        </div>
      </TableWrapper>
      {loading ? (
        <div> </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={teamMembers}
          //filterSearch={true}
          paginate={true}
          viewLink="/view-member"
          editLink="/edit-member"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
          hideView
        />
      )}
    </div>
  );
};

export default TeamTab;

const TableWrapper = styled.div`
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h5 {
        margin-top: 10px;
        font-size: 15px;
        color: #101828;
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 20px;
    h5 {
      font-size: 18px;
      color: #101828;
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #3730a3;
        background-color: #3730a3;
      }
    }
  }
`;
